import { 
	vRoleType,
	User,
} from 'src/app/database-models';

export class UserLookupGroup {
	roleTypes : vRoleType[];
	user : User;
}
